import VueApollo from 'vue-apollo';
import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { onError } from 'apollo-link-error';
import { HttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';

const httpLink = new HttpLink({
  uri: `${process.env.ORIGIN_URL}/graphql`,
});


const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      // Note: we use window.sidekick_defaults && window.sidekick_defaults.serverAccessToken instead of Sidekick.settings
      // because window.sidekick_defaults && window.sidekick_defaults.serverAccessToken is immediately available on the window
      // due to the sidekick application template. This now is stored in sidekick_defaults object read in from the app_icon element.
      // Note: window.sidekick_defaults{billing, sidekick} has been encoded by the wineapp application_helper and stored in the app_icon element.
      //       Can be accessed using Sidekick.decode(path) to get the decoded value.
      'X-Sidekick-Token':
        Sidekick.decode('sidekick.serverAccessToken') || '',
    },
  };
});

const defaultClient = new ApolloClient({
  link: ApolloLink.from([authLink, httpLink]),
  cache: new InMemoryCache(),
  connectToDevTools: true,
  defaultOptions: {
    watchQuery: {
      // fetchPolicy: 'network-only'
      fetchPolicy: 'cache-first',
    },
    query: {
      // fetchPolicy: 'network-only'
      fetchPolicy: 'cache-first',
    },
  },
});

const apollo = new VueApollo({
  defaultClient,
});

export default apollo;



// WEBPACK FOOTER //
// ./src/apollo.js